import Button from 'components/button';
import './card.css';

import React, { useEffect, useRef, useState } from 'react';

import Node from './component/node';

const Card = ({ components }: any) => {
    const [accOpen, setAccOpen] = useState(false);

    console.log('components', components);

    return (
        <div className="card">
            {components.map((component: any, ix: any) => {
                return (
                    <React.Fragment key={ix}>
                        {component.__component == 'editor.text' && (
                            <>
                                {component.Content &&
                                    component.Content.map(
                                        (node: any, index: any) => {
                                            return (
                                                <Node key={index} {...node} />
                                            );
                                        }
                                    )}
                            </>
                        )}
                        {component.__component == 'editor.button' && (
                            <div className="card__button">
                                <Button
                                    href={component.Link}
                                    className={'_default _large'}
                                    active={true}
                                >
                                    {component.Title}
                                </Button>
                            </div>
                        )}
                        {component.__component == 'editor.price-table' && (
                            <div className="price-table">
                                {component.values &&
                                    component.values.length > 0 &&
                                    component.values.map((row: any) => {
                                        return (
                                            <div className="price-row">
                                                <div
                                                    className="price-row__title"
                                                    dangerouslySetInnerHTML={{
                                                        __html: row.Title,
                                                    }}
                                                ></div>
                                                <div className="price-row__count">
                                                    <div className="price-row__count-new">
                                                        {row.Price}
                                                    </div>
                                                    <div className="price-row__count-old">
                                                        {row.Price_second}
                                                    </div>
                                                </div>
                                            </div>
                                        );
                                    })}
                            </div>
                        )}
                        {component.__component == 'editor.step-number' && (
                            <div className="step">
                                <div className="step__number">
                                    {component.Value}
                                </div>
                                <div className="step__title">
                                    {component.Title}
                                </div>
                            </div>
                        )}
                        {component.__component == 'editor.offer' && (
                            <div className="offer">
                                {component.Content &&
                                    component.Content.map(
                                        (node: any, index: any) => {
                                            return (
                                                <Node key={index} {...node} />
                                            );
                                        }
                                    )}
                            </div>
                        )}
                        {component.__component == 'editor.accordion' && (
                            <div
                                className={`acc ${(accOpen && '_open') || ''}`}
                            >
                                <div
                                    className="acc__title"
                                    onClick={(e: any) => {
                                        setAccOpen(!accOpen);
                                    }}
                                >
                                    {component.Title}
                                </div>
                                <div className="acc__value">
                                    {component.Content &&
                                        component.Content.map(
                                            (node: any, index: any) => {
                                                return (
                                                    <Node
                                                        key={index}
                                                        {...node}
                                                    />
                                                );
                                            }
                                        )}
                                </div>
                            </div>
                        )}
                    </React.Fragment>
                );
            })}
        </div>
    );
};

export default Card;
